// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "privacy_deletion_state".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "privacy_deletion_state" table (1:1 with a DB row, on the wire). */
export const privacyDeletionStateAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    subjectType: z.string(),
    subjectId: z.string(),
    deletedAt: z.string().datetime(),
    state: z.unknown(),
});
//# sourceMappingURL=privacyDeletionState.js.map